import React from 'react'

const FunnelStepsListSkeleton = () => (
  <div
    className={`bg-background-secondary inset-0 flex h-fit w-full animate-pulse flex-col overflow-auto rounded-md last:border-b-transparent lg:w-[330px]`}
  >
    <div className="border-b-text-secondary/10 border-b px-8 py-7 ">
      <div className="bg-skeleton-primary my-0.5 h-[40px] rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-8 py-7">
      <div className="bg-skeleton-primary my-0.5 h-[40px] rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-8 py-7">
      <div className="bg-skeleton-primary my-0.5 h-[40px] rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-8 py-7">
      <div className="bg-skeleton-primary my-0.5 h-[40px] rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-8 py-7">
      <div className="bg-skeleton-primary my-0.5 h-[40px] rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-8 py-7">
      <div className="bg-skeleton-primary my-0.5 h-[40px] rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-8 py-7">
      <div className="bg-skeleton-primary my-0.5 h-[40px] rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-8 py-7">
      <div className="bg-skeleton-primary my-0.5 h-[40px] rounded-sm text-transparent">.</div>
    </div>
  </div>
)

export default FunnelStepsListSkeleton
